import { FaCog, FaSearch } from "react-icons/fa"
import Title from "../Title";
import { Link } from 'react-router-dom';
import { getPermission } from "../../classes/functions";

export default function HeaderListing({children, name, permission, url, carrying, itensByPage, setItensByPage, search, termSearch, setTermSearch, pesquisa_status}){
    return (
        <div>
            {carrying 
                ? 
                    <div className="content">
                        <div className="divCarrying">
                            <span>Carregando...</span>
                            <FaCog icon="spinner" className="spinner" />
                        </div>
                    </div>
                :
                    <div className="content">
                        <Title name={name}>
                            {getPermission(permission) && <Link to={url}>
                                <button className="buttonInsert">
                                Cadastrar
                                </button> 
                            </Link>}
                            <select className='selectQtdeItens' value={itensByPage} onChange={ (e) => {setItensByPage(e.target.value); search(e.target.value, termSearch, pesquisa_status);} }>
                                <option value="50">Itens por página</option>
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="40">40</option>
                                <option value="50">50</option>
                            </select>
                            <input className="inputSearch" value={termSearch} type="text" onChange={(e) => setTermSearch(e.target.value)} placeholder="Pesquisar"/>
                            <FaSearch className="iconSearch" style={{color: '#001675' }} size={16}/>
                        </Title>
                        {children}
                    </div>
            }
        </div>
    )
}